/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//   Generated using Swaggie (https://github.com/yhnavein/swaggie)
//   Please avoid doing any manual changes in this file
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
// deno-lint-ignore-file

import Axios, { AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import qs from 'qs';

// OVERWRITTEN - added customErrorHandling param
export interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  customErrorHandling?: boolean | ((response: AxiosResponse) => boolean);
}

export const axios = Axios.create({
  baseURL: '/planning',
  // OVERWRITTEN - added custom params serializer
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});
export const accessTreeClient = {
  /**
   */
  getAccessTree($config?: CustomAxiosRequestConfig): AxiosPromise<AdminUnitAccessTreeNodeDto[]> {
    let url = '/api/access-tree';

    return axios.request<AdminUnitAccessTreeNodeDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const agentClient = {
  /**
   */
  getActiveAgentsForCentre($config?: CustomAxiosRequestConfig): AxiosPromise<AgentDto[]> {
    let url = '/api/agents/centre';

    return axios.request<AgentDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const allowedActionsClient = {
  /**
   */
  getAllowedActions($config?: CustomAxiosRequestConfig): AxiosPromise<AllowedActionsDto> {
    let url = '/api/actions';

    return axios.request<AllowedActionsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getAllowedLrwSessionActions(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwSessionAllowedActionsDto> {
    let url = '/api/actions/lrw-sessions/{lrwSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwSessionAllowedActionsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getAllowedSpeakingSessionActions(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionAllowedActionsDto> {
    let url = '/api/actions/speaking-sessions/{speakingSessionId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionAllowedActionsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const configurationClient = {
  /**
   */
  getCentreConfiguration($config?: CustomAxiosRequestConfig): AxiosPromise<CentreConfigurationDto> {
    let url = '/api/configuration/centre';

    return axios.request<CentreConfigurationDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const examinerClient = {
  /**
   * @param speakingSessionId     */
  getExaminers(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionExaminerDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/examiners';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionExaminerDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getExaminersAllocations(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionExaminerAllocationDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/examiners/allocations';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionExaminerAllocationDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getExaminersAvailabilities(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionExaminerAvailabilityDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/examiners/availabilities';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionExaminerAvailabilityDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const featureFlagsClient = {
  /**
   */
  getAll($config?: CustomAxiosRequestConfig): AxiosPromise<FeatureFlagsDto> {
    let url = '/api/features/all';

    return axios.request<FeatureFlagsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const lrwSessionClient = {
  /**
   * @param lrwSessionId     * @param request     */
  assignRoomsToSession(
    lrwSessionId: number,
    request: AddRoomsToLrwSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/rooms';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param request     */
  createAndLinkSpeakingSession(
    lrwSessionId: number,
    request: CreateAndLinkSpeakingSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<number> {
    let url = '/api/lrw-sessions/{lrwSessionId}/speaking-sessions';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<number>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
  /**
   * @param request     */
  createLrwSession(
    request: CreateLrwSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<number> {
    let url = '/api/lrw-sessions';

    return axios.request<number>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getAssignedRooms(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<AssignedLrwRoomDto[]> {
    let url = '/api/lrw-sessions/{lrwSessionId}/rooms';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<AssignedLrwRoomDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   */
  getAvailableDates(
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<AvailableLrwSessionDateDto[]> {
    let url = '/api/lrw-sessions/dates/available';

    return axios.request<AvailableLrwSessionDateDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param agentId (optional)    */
  getAvailableRoomForSession(
    lrwSessionId: number,
    agentId: number | null | undefined,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwRoomDto[]> {
    let url = '/api/lrw-sessions/{lrwSessionId}/rooms/available';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwRoomDto[]>({
      url: url,
      method: 'GET',
      params: {
        agentId: serializeQueryParam(agentId),
      },
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getAvailableSpeakingSessions(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionForLrwSessionDto[]> {
    let url = '/api/lrw-sessions/{lrwSessionId}/speaking-sessions/available';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<SpeakingSessionForLrwSessionDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param sessionDate     */
  getAvailableVenues(
    sessionDate: string,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<VenueForLrwSessionDto[]> {
    let url = '/api/lrw-sessions/venues/available';

    return axios.request<VenueForLrwSessionDto[]>({
      url: url,
      method: 'GET',
      params: {
        sessionDate: serializeQueryParam(sessionDate),
      },
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getLinkedSessions(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LinkedSpeakingSessionDto[]> {
    let url = '/api/lrw-sessions/{lrwSessionId}/speaking-sessions';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LinkedSpeakingSessionDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getLrwSessionDetails(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwSessionDetailsDto> {
    let url = '/api/lrw-sessions/{lrwSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwSessionDetailsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getLrwSessionExamOverview(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwSessionExamOverviewDto> {
    let url = '/api/lrw-sessions/{lrwSessionId}/exam-overview';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwSessionExamOverviewDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getLrwSessionUpdateData(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwSessionUpdateDataDto> {
    let url = '/api/lrw-sessions/{lrwSessionId}/update-data';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwSessionUpdateDataDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionGetLrwSessionsQuery  (API name: LrwSessionGetLrwSessionsQuery)   */
  getLrwSessions(
    lrwSessionGetLrwSessionsQuery: IGetLrwSessionsFromLrwSessionServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<PagedResultOfLrwSessionDto> {
    let url = '/api/lrw-sessions';

    return axios.request<PagedResultOfLrwSessionDto>({
      url: url,
      method: 'GET',
      params: {
        'filter.fromDate': serializeQueryParam(lrwSessionGetLrwSessionsQuery.filter?.fromDate),
        'filter.toDate': serializeQueryParam(lrwSessionGetLrwSessionsQuery.filter?.toDate),
        'filter.venueIds': serializeQueryParam(lrwSessionGetLrwSessionsQuery.filter?.venueIds),
        'filter.sessionTimes': serializeQueryParam(
          lrwSessionGetLrwSessionsQuery.filter?.sessionTimes
        ),
        'filter.writingFormats': serializeQueryParam(
          lrwSessionGetLrwSessionsQuery.filter?.writingFormats
        ),
        'filter.statuses': serializeQueryParam(lrwSessionGetLrwSessionsQuery.filter?.statuses),
        'pagination.page': serializeQueryParam(lrwSessionGetLrwSessionsQuery.pagination?.page),
        'pagination.pageSize': serializeQueryParam(
          lrwSessionGetLrwSessionsQuery.pagination?.pageSize
        ),
        'sorting.sortField': serializeQueryParam(lrwSessionGetLrwSessionsQuery.sorting?.sortField),
        'sorting.sortDir': serializeQueryParam(lrwSessionGetLrwSessionsQuery.sorting?.sortDir),
        isSortingSpecified: serializeQueryParam(lrwSessionGetLrwSessionsQuery.isSortingSpecified),
        isPaginationSpecified: serializeQueryParam(
          lrwSessionGetLrwSessionsQuery.isPaginationSpecified
        ),
      },
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  getSalesChannelAvailability(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LrwSessionSalesChannelAvailabilityDto> {
    let url = '/api/lrw-sessions/{lrwSessionId}/sales-channel-availability';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<LrwSessionSalesChannelAvailabilityDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   */
  getVenues($config?: CustomAxiosRequestConfig): AxiosPromise<LrwSessionVenueDto[]> {
    let url = '/api/lrw-sessions/venues';

    return axios.request<LrwSessionVenueDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param speakingSessionId     */
  linkSpeakingSession(
    lrwSessionId: number,
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/speaking-sessions/{speakingSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  releaseSession(lrwSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/release';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  releaseSessionWithSpeaking(
    lrwSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/release-with-speaking';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param lrwSessionRoomId     */
  removeLrwSessionRoom(
    lrwSessionId: number,
    lrwSessionRoomId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/rooms/{lrwSessionRoomId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));
    url = url.replace('{lrwSessionRoomId}', encodeURIComponent('' + lrwSessionRoomId));

    return axios.request<any>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     */
  removeSession(lrwSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param speakingSessionId     */
  unlinkSpeakingSession(
    lrwSessionId: number,
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/speaking-sessions/{speakingSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param lrwSessionRoomId     * @param request     */
  updateLrwRoomSeatsLimit(
    lrwSessionId: number,
    lrwSessionRoomId: number,
    request: UpdateSeatLimitRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/rooms/{lrwSessionRoomId}/seat-limit';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));
    url = url.replace('{lrwSessionRoomId}', encodeURIComponent('' + lrwSessionRoomId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param request     */
  updateLrwSession(
    lrwSessionId: number,
    request: UpdateLrwSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
  /**
   * @param lrwSessionId     * @param request     */
  updateSalesChannelAvailability(
    lrwSessionId: number,
    request: UpdateSalesChannelAvailabilityRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/lrw-sessions/{lrwSessionId}/sales-channel-availability';
    url = url.replace('{lrwSessionId}', encodeURIComponent('' + lrwSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
};
export const permissionsClient = {
  /**
   */
  getPermissions($config?: CustomAxiosRequestConfig): AxiosPromise<Permission[]> {
    let url = '/api/permissions';

    return axios.request<Permission[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const permissionTreeClient = {
  /**
   */
  getTreeDefinition($config?: CustomAxiosRequestConfig): AxiosPromise<File> {
    let url = '/api/permissions/tree-definition';

    return axios.request<File>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
};
export const sessionDateAvailabilityClient = {
  /**
   * @param sessionDateAvailabilityGetSessionDateAvailabilitiesCentreContextQuery  (API name: SessionDateAvailabilityGetSessionDateAvailabilitiesCentreContextQuery)   */
  getSessionDateAvailabilitiesCentreContext(
    sessionDateAvailabilityGetSessionDateAvailabilitiesCentreContextQuery: IGetSessionDateAvailabilitiesCentreContextFromSessionDateAvailabilityServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SessionDateAvailabilityDto[]> {
    let url = '/api/session-date-availabilities/centre-context';

    return axios.request<SessionDateAvailabilityDto[]>({
      url: url,
      method: 'GET',
      params: {
        year: serializeQueryParam(
          sessionDateAvailabilityGetSessionDateAvailabilitiesCentreContextQuery.year
        ),
        month: serializeQueryParam(
          sessionDateAvailabilityGetSessionDateAvailabilitiesCentreContextQuery.month
        ),
      },
      ...$config,
    });
  },
  /**
   * @param sessionDateAvailabilityGetSessionDateAvailabilitiesDistrictContextQuery  (API name: SessionDateAvailabilityGetSessionDateAvailabilitiesDistrictContextQuery)   */
  getSessionDateAvailabilitiesDistrictContext(
    sessionDateAvailabilityGetSessionDateAvailabilitiesDistrictContextQuery: IGetSessionDateAvailabilitiesDistrictContextFromSessionDateAvailabilityServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SessionDateAvailabilityDto> {
    let url = '/api/session-date-availabilities/district-context';

    return axios.request<SessionDateAvailabilityDto>({
      url: url,
      method: 'GET',
      params: {
        year: serializeQueryParam(
          sessionDateAvailabilityGetSessionDateAvailabilitiesDistrictContextQuery.year
        ),
        month: serializeQueryParam(
          sessionDateAvailabilityGetSessionDateAvailabilitiesDistrictContextQuery.month
        ),
      },
      ...$config,
    });
  },
  /**
   * @param request     */
  saveSessionDateAvailabilities(
    request: SessionDateAvailabilityRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/session-date-availabilities';

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
};
export const speakingSessionClient = {
  /**
   * @param speakingSessionId     * @param request     */
  assignRooms(
    speakingSessionId: number,
    request: AddRoomsToSpeakingSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/speaking-sessions/{speakingSessionId}/rooms';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
  /**
   * @param request     */
  createSpeakingSession(
    request: CreateSpeakingSessionDto,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<number> {
    let url = '/api/speaking-sessions';

    return axios.request<number>({
      url: url,
      method: 'POST',
      data: request,
      ...$config,
    });
  },
  /**
   */
  getAvailableDates(
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<AvailableSpeakingSessionDateDto[]> {
    let url = '/api/speaking-sessions/dates/available';

    return axios.request<AvailableSpeakingSessionDateDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getAvailableRooms(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<RoomForSpeakingSessionDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/rooms/available';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<RoomForSpeakingSessionDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param sessionDate     */
  getAvailableVenues(
    sessionDate: string,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<VenueForSpeakingSessionDto[]> {
    let url = '/api/speaking-sessions/venues/available';

    return axios.request<VenueForSpeakingSessionDto[]>({
      url: url,
      method: 'GET',
      params: {
        sessionDate: serializeQueryParam(sessionDate),
      },
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getLinkedSessions(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<LinkedLrwSessionDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/lrw-sessions';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<LinkedLrwSessionDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getRooms(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionRoomDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/rooms';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionRoomDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getSpeakingSessionDetails(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<SpeakingSessionDetailsDto> {
    let url = '/api/speaking-sessions/{speakingSessionId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<SpeakingSessionDetailsDto>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  getSpeakingSessionRoomEvents(
    speakingSessionId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<RoomEventDto[]> {
    let url = '/api/speaking-sessions/{speakingSessionId}/rooms/events';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<RoomEventDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param speakingSessionGetSpeakingSessionsQuery  (API name: SpeakingSessionGetSpeakingSessionsQuery)   */
  getSpeakingSessions(
    speakingSessionGetSpeakingSessionsQuery: IGetSpeakingSessionsFromSpeakingSessionServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<PagedResultOfSpeakingSessionDto> {
    let url = '/api/speaking-sessions';

    return axios.request<PagedResultOfSpeakingSessionDto>({
      url: url,
      method: 'GET',
      params: {
        'filter.fromDate': serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.filter?.fromDate
        ),
        'pagination.page': serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.pagination?.page
        ),
        'pagination.pageSize': serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.pagination?.pageSize
        ),
        'sorting.sortField': serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.sorting?.sortField
        ),
        'sorting.sortDir': serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.sorting?.sortDir
        ),
        isSortingSpecified: serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.isSortingSpecified
        ),
        isPaginationSpecified: serializeQueryParam(
          speakingSessionGetSpeakingSessionsQuery.isPaginationSpecified
        ),
      },
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  releaseSession(speakingSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<any> {
    let url = '/api/speaking-sessions/{speakingSessionId}/release';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'POST',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     */
  removeSession(speakingSessionId: number, $config?: CustomAxiosRequestConfig): AxiosPromise<any> {
    let url = '/api/speaking-sessions/{speakingSessionId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     * @param speakingSessionRoomId     */
  removeSpeakingSessionRoom(
    speakingSessionId: number,
    speakingSessionRoomId: number,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/speaking-sessions/{speakingSessionId}/rooms/{speakingSessionRoomId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));
    url = url.replace('{speakingSessionRoomId}', encodeURIComponent('' + speakingSessionRoomId));

    return axios.request<any>({
      url: url,
      method: 'DELETE',
      ...$config,
    });
  },
  /**
   * @param speakingSessionId     * @param request     */
  updateSpeakingSession(
    speakingSessionId: number,
    request: UpdateSpeakingSessionRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url = '/api/speaking-sessions/{speakingSessionId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
};
export const speakingSessionRoomClient = {
  /**
   * @param speakingSessionId     * @param speakingSessionRoomId     * @param request     */
  editSpeakingSessionRoom(
    speakingSessionId: number,
    speakingSessionRoomId: number,
    request: EditSpeakingSessionRoomRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url =
      '/api/speaking-sessions/{speakingSessionId}/speaking-sessions-rooms/{speakingSessionRoomId}';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));
    url = url.replace('{speakingSessionRoomId}', encodeURIComponent('' + speakingSessionRoomId));

    return axios.request<any>({
      url: url,
      method: 'PUT',
      data: request,
      ...$config,
    });
  },
};
export const speakingSessionRoomStructureClient = {
  /**
   * @param speakingSessionId     * @param speakingSessionRoomId     * @param speakingSessionRoomStructureId     * @param request     */
  assignExaminer(
    speakingSessionId: number,
    speakingSessionRoomId: number,
    speakingSessionRoomStructureId: number,
    request: AssignExaminerRequest,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<any> {
    let url =
      '/api/speaking-sessions/{speakingSessionId}/speaking-sessions-rooms/{speakingSessionRoomId}/speaking-sessions-room-structures/{speakingSessionRoomStructureId}/examiner';
    url = url.replace('{speakingSessionId}', encodeURIComponent('' + speakingSessionId));
    url = url.replace('{speakingSessionRoomId}', encodeURIComponent('' + speakingSessionRoomId));
    url = url.replace(
      '{speakingSessionRoomStructureId}',
      encodeURIComponent('' + speakingSessionRoomStructureId)
    );

    return axios.request<any>({
      url: url,
      method: 'PATCH',
      data: request,
      ...$config,
    });
  },
};
export const testCentreOverviewClient = {
  /**
   * @param testCentreOverviewGetDatesQuery  (API name: TestCentreOverviewGetDatesQuery)   */
  getDates(
    testCentreOverviewGetDatesQuery: IGetDatesFromTestCentreOverviewServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewDateDto[]> {
    let url = '/api/test-centre-overview/dates';

    return axios.request<TestCentreOverviewDateDto[]>({
      url: url,
      method: 'GET',
      params: {
        fromDate: serializeQueryParam(testCentreOverviewGetDatesQuery.fromDate),
        toDate: serializeQueryParam(testCentreOverviewGetDatesQuery.toDate),
        districtIds: serializeQueryParam(testCentreOverviewGetDatesQuery.districtIds),
        venueIds: serializeQueryParam(testCentreOverviewGetDatesQuery.venueIds),
        sessionTimes: serializeQueryParam(testCentreOverviewGetDatesQuery.sessionTimes),
      },
      ...$config,
    });
  },
  /**
   */
  getDistricts(
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewAvailableDistrictDto[]> {
    let url = '/api/test-centre-overview/districts';

    return axios.request<TestCentreOverviewAvailableDistrictDto[]>({
      url: url,
      method: 'GET',
      ...$config,
    });
  },
  /**
   * @param date     * @param testCentreOverviewGetDistrictsForDateQuery  (API name: TestCentreOverviewGetDistrictsForDateQuery)   */
  getDistrictsForDate(
    date: string,
    testCentreOverviewGetDistrictsForDateQuery: IGetDistrictsForDateFromTestCentreOverviewServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewDistrictDto[]> {
    let url = '/api/test-centre-overview/dates/{date}/districts';
    url = url.replace('{date}', encodeURIComponent('' + date));

    return axios.request<TestCentreOverviewDistrictDto[]>({
      url: url,
      method: 'GET',
      params: {
        fromDate: serializeQueryParam(testCentreOverviewGetDistrictsForDateQuery.fromDate),
        toDate: serializeQueryParam(testCentreOverviewGetDistrictsForDateQuery.toDate),
        districtIds: serializeQueryParam(testCentreOverviewGetDistrictsForDateQuery.districtIds),
        venueIds: serializeQueryParam(testCentreOverviewGetDistrictsForDateQuery.venueIds),
        sessionTimes: serializeQueryParam(testCentreOverviewGetDistrictsForDateQuery.sessionTimes),
      },
      ...$config,
    });
  },
  /**
   * @param date     * @param districtId     * @param testCentreOverviewGetSessionsForDistrictQuery  (API name: TestCentreOverviewGetSessionsForDistrictQuery)   */
  getSessionsForDistrict(
    date: string,
    districtId: number,
    testCentreOverviewGetSessionsForDistrictQuery: IGetSessionsForDistrictFromTestCentreOverviewServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewSessionDto[]> {
    let url = '/api/test-centre-overview/dates/{date}/districts/{districtId}/sessions';
    url = url.replace('{date}', encodeURIComponent('' + date));
    url = url.replace('{districtId}', encodeURIComponent('' + districtId));

    return axios.request<TestCentreOverviewSessionDto[]>({
      url: url,
      method: 'GET',
      params: {
        fromDate: serializeQueryParam(testCentreOverviewGetSessionsForDistrictQuery.fromDate),
        toDate: serializeQueryParam(testCentreOverviewGetSessionsForDistrictQuery.toDate),
        districtIds: serializeQueryParam(testCentreOverviewGetSessionsForDistrictQuery.districtIds),
        venueIds: serializeQueryParam(testCentreOverviewGetSessionsForDistrictQuery.venueIds),
        sessionTimes: serializeQueryParam(
          testCentreOverviewGetSessionsForDistrictQuery.sessionTimes
        ),
      },
      ...$config,
    });
  },
  /**
   * @param testCentreOverviewGetSummaryQuery  (API name: TestCentreOverviewGetSummaryQuery)   */
  getSummary(
    testCentreOverviewGetSummaryQuery: IGetSummaryFromTestCentreOverviewServiceQuery,
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewSummaryDto> {
    let url = '/api/test-centre-overview/summary';

    return axios.request<TestCentreOverviewSummaryDto>({
      url: url,
      method: 'GET',
      params: {
        fromDate: serializeQueryParam(testCentreOverviewGetSummaryQuery.fromDate),
        toDate: serializeQueryParam(testCentreOverviewGetSummaryQuery.toDate),
        districtIds: serializeQueryParam(testCentreOverviewGetSummaryQuery.districtIds),
        venueIds: serializeQueryParam(testCentreOverviewGetSummaryQuery.venueIds),
        sessionTimes: serializeQueryParam(testCentreOverviewGetSummaryQuery.sessionTimes),
      },
      ...$config,
    });
  },
  /**
   * @param districtIds     */
  getVenues(
    districtIds: number[],
    $config?: CustomAxiosRequestConfig
  ): AxiosPromise<TestCentreOverviewVenueDto[]> {
    let url = '/api/test-centre-overview/venues';

    return axios.request<TestCentreOverviewVenueDto[]>({
      url: url,
      method: 'GET',
      params: {
        districtIds: serializeQueryParam(districtIds),
      },
      ...$config,
    });
  },
};
function serializeQueryParam(obj: any) {
  // OVERWRITTEN - do not convert undefined props as string for proper API validation
  // if (obj === null || obj === undefined) return '';
  if (obj === null || obj === undefined) return undefined;
  if (obj instanceof Date) return obj.toJSON();
  if (typeof obj !== 'object' || Array.isArray(obj)) return obj;
  return Object.keys(obj)
    .reduce((a: any, b) => a.push(b + '=' + obj[b]) && a, [])
    .join('&');
}
export interface AdminUnitAccessTreeNodeDto {
  value: AdminUnitAccessDto;
  children: AdminUnitAccessTreeNodeDto[];
  hasAccess: boolean;
}

export interface AdminUnitAccessDto {
  objectId: number;
  type: AdminUnitTypeEnum;
  name: string;
}

export enum AdminUnitTypeEnum {
  Organisation = 3,
  Center = 4,
  District = 5,
  OrganisationCountry = 7,
  Hub = 12,
}

export interface AgentDto {
  id: number;
  name: string;
}

export interface AllowedActionsDto {
  canEditExamDatesForLocations: boolean;
  canCreateLrwSession: boolean;
  canCreateSpeakingSession: boolean;
  canViewSpeakingSession: boolean;
  canViewLrwSession: boolean;
  canViewExamDatesForLocations: boolean;
}

export interface LrwSessionAllowedActionsDto {
  canUpdateLrwSession: boolean;
  canRemoveLrwSession: boolean;
  canReleaseLrwSession: boolean;
  canAssignRooms: boolean;
  canRemoveRoom: boolean;
  canChangeSeatsLimit: boolean;
  cantLinkSpeakingSessionReasons: string[];
  canLinkSpeakingSession: boolean;
  canUnlinkSpeakingSession: boolean;
  canPrintExamMaterials: boolean;
  canUpdateSalesChannelAvailability: boolean;
}

export interface SpeakingSessionAllowedActionsDto {
  canReleaseSession: boolean;
  canRemoveSession: boolean;
  canEditSession: boolean;
  canAssignRooms: boolean;
  canRemoveRooms: boolean;
  canManageSpeakingStructuresAndSlots: boolean;
  canUnlinkLrwSessions: boolean;
  canLinkLrwSessions: boolean;
  canAssignExaminers: boolean;
  canPrintExamMaterials: boolean;
}

export interface CentreConfigurationDto {
  isIeltsFlexiblePlanningEnabled: boolean;
  isUkviFlexiblePlanningEnabled: boolean;
  districtConfigurations: DistrictConfigurationDto[];
}

export interface DistrictConfigurationDto {
  districtId: number;
  isIeltsFlexiblePlanningEnabled: boolean;
  isUkviFlexiblePlanningEnabled: boolean;
}

export interface SpeakingSessionExaminerDto {
  id: number;
  examinerNumber?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  districtId?: number;
}

export interface SpeakingSessionExaminerAllocationDto {
  examinerId: number;
  startDateTime: string;
  endDateTime: string;
}

export interface SpeakingSessionExaminerAvailabilityDto {
  examinerId: number;
  startDateTime: string;
  endDateTime: string;
  availabilityType: AvailabilityType;
}

export enum AvailabilityType {
  Available = 1,
  Unavailable = 2,
}

export interface FeatureFlagsDto {
  isComputerMediatedSpeakingEnabled: boolean;
}

export interface VenueForLrwSessionDto {
  id: number;
  name: string;
  supportsOnComputer: boolean;
  supportsOnPaper: boolean;
}

export interface LrwSessionVenueDto {
  id: number;
  name: string;
}

export interface AvailableLrwSessionDateDto {
  date: string;
}

export interface PagedResultOfLrwSessionDto {
  totalCount: number;
  results?: LrwSessionDto[];
}

export interface LrwSessionDto {
  id: number;
  date: string;
  startTime: string;
  endTime: string;
  venue: string;
  status: SessionStatus;
  numberOfAssignedRooms: number;
  numberOfRegistrations: number;
  onComputerWritingFormats: OnComputerWritingFormat[];

  linkedSpeakingSessionId?: number;
}

export enum SessionStatus {
  Unreleased = 0,
  Released = 1,
}

export enum OnComputerWritingFormat {
  OnComputer = 1,
  OnPaper = 2,
}

export enum ExamTimeOfDay {
  Morning = 0,
  Afternoon = 1,
  Evening = 2,
}

export enum SortDirection {
  Undefined = 0,
  Asc = 1,
  Desc = 2,
}

export interface LrwSessionDetailsDto {
  date: string;
  startTime: string;
  endTime: string;
  venueId: number;
  venue: string;
  testTakerAdmissionTimeMinutes: number;
  status: SessionStatus;
  onComputerWritingFormats: OnComputerWritingFormat[];
}

export interface LrwSessionUpdateDataDto {
  updateCapabilities: LrwSessionUpdateCapabilitiesDto;
}

export interface LrwSessionUpdateCapabilitiesDto {
  canUpdateTimeBlock: boolean;
  canEnableOnComputerWritingFormat: boolean;
  canDisableOnComputerWritingFormat: boolean;
  canEnableOnPaperWritingFormat: boolean;
  canDisableOnPaperWritingFormat: boolean;
}

export interface CreateLrwSessionRequest {
  sessionDate: string;
  sessionStartTime: string;
  sessionEndTime: string;
  venueId: number;
  testTakerAdmissionTimeMinutes: number;
  onPaperEnabled: boolean;
  onComputerEnabled: boolean;
}

export interface UpdateLrwSessionRequest {
  sessionStartTime: string;
  sessionEndTime: string;
  testTakerAdmissionTimeMinutes: number;
  onPaperEnabled: boolean;
  onComputerEnabled: boolean;
}

export interface SpeakingSessionForLrwSessionDto {
  id: number;
  date: string;
  venueId: number;
  venueName: string;
  firstSlotStartTime: string;
  lastSlotEndTime: string;
  plannedSlots: number;
}

export interface LinkedSpeakingSessionDto {
  id: number;
  date: string;
  venueName: string;
  plannedSlots: number;
  bookedSpeakingSlots: number;
  availableSlots: number;
  bookedSharedSeats: number;
}

export interface CreateAndLinkSpeakingSessionRequest {
  venueId: number;
  testTakerAdmissionTimeMinutes: number;
}

export interface LrwRoomDto {
  id: number;
  buildingName: string;
  name: string;
  totalSeats: number;
  maxSeatLimit: number;
  floor: string;
  clashes: LrwRoomClashDto[];
}

export interface LrwRoomClashDto {
  isIeltsExam: boolean;
  startTime: string;
  endTime: string;
  format?: OnComputerWritingFormat;
  productName?: string;
  component?: string;
}

export interface AddRoomsToLrwSessionRequest {
  rooms: AssignedLrwRoom[];
}

export interface AssignedLrwRoom {
  roomId: number;
  seatLimit: number;
  agentId?: number;
}

export interface UpdateSeatLimitRequest {
  seatLimit: number;
}

export interface AssignedLrwRoomDto {
  id: number;
  roomId: string;
  buildingName: string;
  name: string;
  totalSeats: number;
  floor: string;
  seatLimit: number;
  registrationsCount: number;
  agentName?: string;
}

export interface LrwSessionSalesChannelAvailabilityDto {
  adminClosingDate: string;
  b2CClosingDate: string;
  b2BClosingDate: string;
  adminAvailable: boolean;
  b2CAvailable: boolean;
  b2BAvailable: boolean;
  organisationalAvailable: boolean;
  areChannelsEditable: boolean;
  organisationalClosingDate?: string;
}

export interface UpdateSalesChannelAvailabilityRequest {
  adminClosingDate: string;
  b2CClosingDate: string;
  b2BClosingDate: string;
  adminAvailable: boolean;
  b2CAvailable: boolean;
  b2BAvailable: boolean;
  organisationalAvailable: boolean;
  organisationalClosingDate?: string;
}

export interface LrwSessionExamOverviewDto {
  plannedLrwSeats: number;
  bookedLrwSeats: number;
  plannedSpeakingSlots: number;
  bookedSpeakingSlots: number;
  overlapLrw: number;
  missingToCoverLrw: number;
  speakingSessionRooms: SpeakingSessionRoomOverviewDto[];
  lrwSessionRooms: LrwSessionRoomOverviewDto[];
  otherLrwSessionRooms: OtherLrwSessionRoomOverviewDto[];
  otherLrwPlannedSeats: number;
}

export interface SpeakingSessionRoomOverviewDto {
  name: string;
  speakingSlots: SpeakingSlotOverviewDto[];
}

export interface SpeakingSlotOverviewDto {
  startTime: string;
  endTime: string;
  status: SpeakingSlotStatus;
  speakingSlotType: SpeakingSlotType;
  plannedCapacity: number;
  availableCapacity: number;
}

export enum SpeakingSlotStatus {
  Available = 0,
  AwaitingApproval = 1,
  Booked = 2,
  Break = 3,
  Rejected = 4,
}

export enum SpeakingSlotType {
  IPC = 1,
  IPA = 2,
  RSS = 3,
  SWA = 4,
}

export interface LrwSessionRoomOverviewDto {
  name: string;
  startTime: string;
  endTime: string;
  plannedCapacity: number;
  availableCapacity: number;
}

export interface OtherLrwSessionRoomOverviewDto {
  name: string;
  startTime: string;
  endTime: string;
}

export enum Permission {
  ViewPlanningSession = 1,
  ManagePlanningSession = 2,
  EditSaleChannelAvailability = 3,
}

export interface SessionDateAvailabilityDto {
  districtId: number;
  districtName: string;
  dates: DateDetails[];
}

export interface DateDetails {
  date: string;
}

export interface SessionDateAvailabilityRequest {
  dateToCreate: DateAvailability[];
  dateToDelete: DateAvailability[];
}

export interface DateAvailability {
  districtId: number;
  date: string;
}

export interface VenueForSpeakingSessionDto {
  id: number;
  name: string;
}

export interface AvailableSpeakingSessionDateDto {
  date: string;
}

export interface PagedResultOfSpeakingSessionDto {
  totalCount: number;
  results?: SpeakingSessionDto[];
}

export interface SpeakingSessionDto {
  id: number;
  date: string;
  venue: string;
  hasLinkedLrwSessions: boolean;
  status: SessionStatus;
  numberOfPlannedSlots: number;
  numberOfRegistrations: number;
}

export interface SpeakingSessionDetailsDto {
  date: string;
  venue: string;
  status: SessionStatus;
  testTakerAdmissionTimeMinutes: number;
  localSpeakingSlotMinutesOffset: number;
}

export interface LinkedLrwSessionDto {
  id: number;
  date: string;
  startTime: string;
  endTime: string;
  venue: string;
}

export interface RoomForSpeakingSessionDto {
  id: number;
  name: string;
  building: string;
  floor: string;
  availableSpeakingSlotTypes: SpeakingSlotType[];
  roomReservations: RoomReserved[];
}

export interface RoomReserved {
  isIeltsExam: boolean;
  startTime: string;
  endTime: string;
  componentName?: string;
  productName?: string;
  examFormat?: ExamFormat;
}

export enum ExamFormat {
  PB = 1,
  CD = 2,
}

export interface SpeakingSessionRoomDto {
  id: number;
  roomId: number;
  name: string;
  availableSpeakingSlotTypes: SpeakingSlotType[];
  roomStructures: SpeakingSessionRoomStructureDto[];
  canEdit: boolean;
  canRemove: boolean;
  capacity: number;
}

export interface SpeakingSessionRoomStructureDto {
  id: number;
  speakingSlotType: SpeakingSlotType;
  speakingSlots: SpeakingSlotDto[];
  assignedExaminer?: SpeakingSessionRoomStructureAssignedExaminerDto;
}

export interface SpeakingSlotDto {
  status: SpeakingSlotStatus;
  startTime: string;
  endTime: string;
  plannedCapacity: number;
  availableCapacity: number;
  booking?: SpeakingSlotRegistrationCandidateDto;
}

export interface SpeakingSlotRegistrationCandidateDto {
  isMinor: boolean;
  isYoungAdult: boolean;
  hasAccessArrangements: boolean;
  firstName?: string;
  surname?: string;
  dateOfBirth?: string;
  postCode?: string;
  city?: string;
  phoneNumber?: string;
}

export interface SpeakingSessionRoomStructureAssignedExaminerDto {
  examinerId: number;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  examinerNumber?: string;
}

export interface AddRoomsToSpeakingSessionRequest {
  rooms: number[];
}

export interface CreateSpeakingSessionDto {
  sessionDate: string;
  venueId: number;
  testTakerAdmissionTimeMinutes: number;
}

export interface UpdateSpeakingSessionRequest {
  testTakerAdmissionTimeMinutes: number;
}

export interface RoomEventDto {
  roomId: number;
  startTime: string;
  endTime: string;
}

export interface EditSpeakingSessionRoomRequest {
  roomStructures: EditSpeakingSessionRoomStructure[];
}

export interface EditSpeakingSessionRoomStructure {
  id: number;
  speakingSlotType: SpeakingSlotType;
  speakingSlots: EditSpeakingSlot[];
}

export interface EditSpeakingSlot {
  status: SpeakingSlotStatus;
  startTime: string;
  endTime: string;
  plannedCapacity: number;
}

export interface AssignExaminerRequest {
  examinerId: number;
}

export interface TestCentreOverviewAvailableDistrictDto {
  id: number;
  name: string;
}

export interface TestCentreOverviewVenueDto {
  id: number;
  name: string;
}

export interface TestCentreOverviewSummaryDto {
  lrwReleasedSeats: number;
  lrwUnreleasedSeats: number;
  confirmedRegistrations: number;
  incompleteRegistrations: number;
  speakingReleasedSlots: number;
  speakingUnreleasedSlots: number;
  speakingAwaitingConfirmationSlots: number;
  unassignedInPersonSpeakingSlots: number;
  plannedLrwCapacity: number;
  totalRegistrations: number;
  plannedSpeakingSlots: number;
  inPersonExaminersCoverage: number;
}

export interface TestCentreOverviewDateDto {
  date: string;
  speakingPlannedSlots: number;
  speakingBookedSlots: number;
  speakingOsrBookedSlots: number;
  speakingExaminersAssigned: number;
  speakingExaminersUnassigned: number;
  lrwPlannedSeats: number;
  lrwBookedSeats: number;
  lrwAcBookedSeats: number;
  lrwGtBookedSeats: number;
  lrwOsrBookedSeats: number;
  confirmedRegistrations: number;
  unconfirmedRegistrations: number;
  utilisation: number;
}

export interface TestCentreOverviewDistrictDto {
  districtId: number;
  districtName: string;
  speakingPlannedSlots: number;
  speakingBookedSlots: number;
  speakingOsrBookedSlots: number;
  speakingExaminersAssigned: number;
  speakingExaminersUnassigned: number;
  lrwPlannedSeats: number;
  lrwBookedSeats: number;
  lrwAcBookedSeats: number;
  lrwGtBookedSeats: number;
  lrwOsrBookedSeats: number;
  confirmedRegistrations: number;
  unconfirmedRegistrations: number;
  utilisation: number;
}

export interface TestCentreOverviewSessionDto {
  lrwPairings: TestCentreOverviewLrwPairingDto[];
  speakingSession?: TestCentreOverviewSpeakingSessionDto;
}

export interface TestCentreOverviewSpeakingSessionDto {
  venueName: string;
  plannedSlots: number;
  bookedSlots: number;
  osrBookedSlots: number;
  examinersAssigned: number;
  examinersUnassigned: number;
}

export interface TestCentreOverviewLrwPairingDto {
  confirmedRegistrations: number;
  unconfirmedRegistrations: number;
  utilisation: number;
  lrwSession?: TestCentreOverviewLrwSessionDto;
}

export interface TestCentreOverviewLrwSessionDto {
  venueName: string;
  startTime: string;
  endTime: string;
  plannedSeats: number;
  bookedSeats: number;
  acBookedSeats: number;
  gtBookedSeats: number;
  osrBookedSeats: number;
}

export interface IGetLrwSessionsFromLrwSessionServiceQuery {
  filter?: {
    fromDate?: string;
    toDate?: string;
    venueIds?: number[];
    sessionTimes?: ExamTimeOfDay[];
    writingFormats?: OnComputerWritingFormat[];
    statuses?: SessionStatus[];
  };
  pagination?: {
    page?: number;
    pageSize?: number;
  };
  sorting?: {
    sortField?: string;
    sortDir?: SortDirection;
  };
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface IGetSessionDateAvailabilitiesCentreContextFromSessionDateAvailabilityServiceQuery {
  year?: number;
  month?: number;
}

export interface IGetSessionDateAvailabilitiesDistrictContextFromSessionDateAvailabilityServiceQuery {
  year?: number;
  month?: number;
}

export interface IGetSpeakingSessionsFromSpeakingSessionServiceQuery {
  filter?: {
    fromDate?: string;
  };
  pagination?: {
    page?: number;
    pageSize?: number;
  };
  sorting?: {
    sortField?: string;
    sortDir?: SortDirection;
  };
  isSortingSpecified?: boolean;
  isPaginationSpecified?: boolean;
}

export interface IGetDatesFromTestCentreOverviewServiceQuery {
  fromDate?: string;
  toDate?: string;
  districtIds?: number[];
  venueIds?: number[];
  sessionTimes?: ExamTimeOfDay[];
}

export interface IGetDistrictsForDateFromTestCentreOverviewServiceQuery {
  fromDate?: string;
  toDate?: string;
  districtIds?: number[];
  venueIds?: number[];
  sessionTimes?: ExamTimeOfDay[];
}

export interface IGetSessionsForDistrictFromTestCentreOverviewServiceQuery {
  fromDate?: string;
  toDate?: string;
  districtIds?: number[];
  venueIds?: number[];
  sessionTimes?: ExamTimeOfDay[];
}

export interface IGetSummaryFromTestCentreOverviewServiceQuery {
  fromDate?: string;
  toDate?: string;
  districtIds?: number[];
  venueIds?: number[];
  sessionTimes?: ExamTimeOfDay[];
}
